var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.169,
    height: 119.168,
    viewBox: "0 0 119.169 119.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f3951;}.b{fill:none;stroke:#1f3951;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996, 0.087, -0.087, 0.996, -17.658, -35.86)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.267 33.349)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M98.793,39.156l.324-5.807L100,33.4l-.139,2.488,2.813.157.139-2.488.879.049-.324,5.807-.879-.049.145-2.6-2.812-.157-.145,2.6Z",
    transform: "translate(-43.296 -33.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.841,40.535a2.924,2.924,0,0,1-1.4-.678,2.691,2.691,0,0,1-.781-1.241,3.537,3.537,0,0,1,.627-3.069,2.689,2.689,0,0,1,1.206-.835,3.182,3.182,0,0,1,2.962.606,2.662,2.662,0,0,1,.776,1.24,3.576,3.576,0,0,1-.628,3.069,2.657,2.657,0,0,1-1.2.836A2.925,2.925,0,0,1,109.841,40.535Zm.158-.773a2,2,0,0,0,1.075-.052,1.8,1.8,0,0,0,.833-.61,2.958,2.958,0,0,0,.477-2.328,1.814,1.814,0,0,0-.527-.888,2,2,0,0,0-.968-.469,2.021,2.021,0,0,0-1.079.051,1.772,1.772,0,0,0-.833.61A3,3,0,0,0,108.5,38.4a1.767,1.767,0,0,0,.526.888A2.015,2.015,0,0,0,110,39.761Z",
    transform: "translate(-44.958 -33.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M117.57,42.321l1.673-4.819-1.625-.564.234-.674,4.074,1.413-.234.675-1.617-.561L118.4,42.61Z",
    transform: "translate(-46.866 -33.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M122.735,44.485l2.547-5.229,3.324,1.619-.313.642-2.532-1.233-.794,1.628,2.308,1.124-.306.627-2.308-1.124-.822,1.688,2.532,1.233-.313.643Z",
    transform: "translate(-47.849 -34.468)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M129.117,47.86l3.133-4.9.742.475-2.757,4.311,2.226,1.423-.376.588Z",
    transform: "translate(-49.061 -35.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M139.934,56.393a2.839,2.839,0,0,1-.817-1.3,2.534,2.534,0,0,1,.029-1.431,3.8,3.8,0,0,1,2.17-2.27,2.56,2.56,0,0,1,1.431-.1,2.807,2.807,0,0,1,1.342.754,2.662,2.662,0,0,1,.863,1.514,2.224,2.224,0,0,1-.37,1.577l-.709-.678a1.379,1.379,0,0,0,.2-.926,1.614,1.614,0,0,0-.533-.922,1.718,1.718,0,0,0-1.408-.523,2.433,2.433,0,0,0-1.494.83,2.406,2.406,0,0,0-.753,1.521,1.722,1.722,0,0,0,.59,1.379,1.675,1.675,0,0,0,.934.5,1.3,1.3,0,0,0,.894-.214l.708.678a2.168,2.168,0,0,1-1.529.41A2.693,2.693,0,0,1,139.934,56.393Z",
    transform: "translate(-50.96 -36.737)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M145.893,63.026a2.929,2.929,0,0,1-.625-1.428,2.689,2.689,0,0,1,.216-1.451,3.537,3.537,0,0,1,2.474-1.92,2.69,2.69,0,0,1,1.459.151,3.183,3.183,0,0,1,1.854,2.389,2.657,2.657,0,0,1-.217,1.447,3.572,3.572,0,0,1-2.475,1.92,2.656,2.656,0,0,1-1.456-.148A2.919,2.919,0,0,1,145.893,63.026Zm.624-.484a1.987,1.987,0,0,0,.849.661,1.8,1.8,0,0,0,1.029.079,2.956,2.956,0,0,0,1.877-1.457,1.8,1.8,0,0,0,.178-1.017,2.182,2.182,0,0,0-1.281-1.65,1.774,1.774,0,0,0-1.029-.079,3.006,3.006,0,0,0-1.877,1.457,1.779,1.779,0,0,0-.178,1.017A2.008,2.008,0,0,0,146.517,62.542Z",
    transform: "translate(-52.138 -38.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M149.694,68.31l5.1-2.788.5.912-2.453,3.584,4.338-.135.5.911-5.1,2.788-.422-.773,3.77-2.059-3.893.1-.327-.6,2.177-3.224-3.762,2.055Z",
    transform: "translate(-52.981 -39.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M154.287,77.536l5.444-2.043,1.282,3.415-.669.251-.973-2.59-1.719.645.806,2.147-.661.248-.806-2.147-2.4.9Z",
    transform: "translate(-53.851 -41.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.2,86.883a2.923,2.923,0,0,1,.036-1.559,2.689,2.689,0,0,1,.807-1.224,3.534,3.534,0,0,1,3.053-.7,2.679,2.679,0,0,1,1.258.752,3.183,3.183,0,0,1,.674,2.948,2.662,2.662,0,0,1-.808,1.221,3.578,3.578,0,0,1-3.053.7,2.66,2.66,0,0,1-1.257-.748A2.915,2.915,0,0,1,157.2,86.883Zm.769-.176a1.985,1.985,0,0,0,.491.957,1.805,1.805,0,0,0,.9.507,2.958,2.958,0,0,0,2.316-.529,1.808,1.808,0,0,0,.591-.846,2.185,2.185,0,0,0-.466-2.037,1.768,1.768,0,0,0-.9-.507,3,3,0,0,0-2.317.528,1.78,1.78,0,0,0-.591.847A2.019,2.019,0,0,0,157.968,86.707Z",
    transform: "translate(-54.386 -42.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M158.437,93.544l5.794-.494.171,1.995a2.446,2.446,0,0,1-.136,1.15,1.543,1.543,0,0,1-.568.711,1.8,1.8,0,0,1-.855.29,1.766,1.766,0,0,1-1-.2,1.583,1.583,0,0,1-.7-.836L158.782,97.6l-.087-1.019,2.238-1.324-.088-1.035-2.334.2Zm3.071.622.092,1.067a1.163,1.163,0,0,0,.364.849,1.047,1.047,0,0,0,.776.213,1.016,1.016,0,0,0,.719-.336,1.208,1.208,0,0,0,.2-.909l-.09-1.059Z",
    transform: "translate(-54.638 -44.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M158.834,102.514l5.1.177.058-1.718.716.024-.151,4.31-.713-.025.058-1.71-5.1-.178Z",
    transform: "translate(-54.707 -46.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M156.964,114.858a2.713,2.713,0,0,1,.7-1.311,2.541,2.541,0,0,1,1.24-.686,3.439,3.439,0,0,1,1.606.035,3.384,3.384,0,0,1,1.445.705,2.594,2.594,0,0,1,.807,1.214,2.9,2.9,0,0,1,.021,1.572,2.765,2.765,0,0,1-.855,1.5,2.21,2.21,0,0,1-1.495.531l.233-.969a1.291,1.291,0,0,0,.833-.339,1.75,1.75,0,0,0,.492-.916,1.822,1.822,0,0,0-.239-1.535,2.8,2.8,0,0,0-3.157-.764,1.74,1.74,0,0,0-.885,1.2,1.65,1.65,0,0,0,.174,1.379,2.208,2.208,0,0,0,1.149.8l.368-1.535.662.159-.575,2.4-3.07-.735.188-.784.849.127a2.077,2.077,0,0,1-.516-.875A2.319,2.319,0,0,1,156.964,114.858Z",
    transform: "translate(-54.255 -48.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M154.436,123.273a2.536,2.536,0,0,1,.644-.956,1.846,1.846,0,0,1,.993-.464,2.538,2.538,0,0,1,1.306.2l3.374,1.341-.326.819-3.382-1.344a1.506,1.506,0,0,0-1.177-.075,1.534,1.534,0,0,0-.727,1.829,1.509,1.509,0,0,0,.907.754l3.382,1.345-.325.818L155.73,126.2a2.478,2.478,0,0,1-1.085-.758,1.886,1.886,0,0,1-.4-1.034A2.567,2.567,0,0,1,154.436,123.273Z",
    transform: "translate(-53.843 -50.178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M152.174,127.987l4.032,4.707-.47.841-6.115-.978.454-.813,1.483.258,1.158-2.075-1-1.127Zm1.031,2.5-.915,1.639,2.771.473Z",
    transform: "translate(-52.967 -51.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M147.745,135.545l4.665,3.472-1.2,1.606a2.434,2.434,0,0,1-.864.77,1.542,1.542,0,0,1-.9.156,1.786,1.786,0,0,1-.832-.35,1.759,1.759,0,0,1-.616-.815,1.593,1.593,0,0,1,.027-1.093l-2.718-.48.61-.819,2.554.492.62-.833-1.879-1.4Zm1.886,2.5-.64.859a1.167,1.167,0,0,0-.29.877,1.044,1.044,0,0,0,.44.674,1.013,1.013,0,0,0,.76.224,1.205,1.205,0,0,0,.754-.547l.635-.853Z",
    transform: "translate(-52.151 -52.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M143.171,141.152l2.686,5.585-.67.692-5.657-2.517.647-.669,1.367.631,1.653-1.707-.674-1.346Zm.354,2.68-1.306,1.349,2.556,1.169Z",
    transform: "translate(-51.055 -53.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M136.946,147.31l3.583,4.58-.694.543-5-1.652,2.7,3.449-.694.542-3.583-4.58.694-.543,4.994,1.652-2.7-3.449Z",
    transform: "translate(-49.851 -55.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M129.321,153.251l2.6,4.391,1.48-.876.364.615-3.711,2.2-.363-.615,1.473-.871-2.6-4.39Z",
    transform: "translate(-48.957 -56.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M123.864,155.925l2.347,5.32-3.382,1.492-.289-.654,2.577-1.136-.731-1.657-2.349,1.036-.282-.639,2.349-1.036-.758-1.718-2.577,1.137-.289-.653Z",
    transform: "translate(-47.42 -56.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M117.186,158.674l1.7,5.563-3.536,1.079-.209-.684,2.694-.822-.528-1.732-2.456.749-.2-.667,2.455-.749-.548-1.8-2.693.822-.208-.683Z",
    transform: "translate(-46.121 -57.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M106.057,163.539a1.035,1.035,0,0,1,.545.072,1.092,1.092,0,0,1,.431.326,1,1,0,0,1,.213.513,1.021,1.021,0,0,1-.075.554,1.092,1.092,0,0,1-.334.429,1.032,1.032,0,0,1-.51.207,1.043,1.043,0,0,1-.554-.07,1.058,1.058,0,0,1-.428-.331,1.044,1.044,0,0,1-.208-.517,1.024,1.024,0,0,1,.071-.55,1.057,1.057,0,0,1,.331-.424A1.044,1.044,0,0,1,106.057,163.539Z",
    transform: "translate(-44.499 -58.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.908,161.961l-.278,5.808-.879-.042.119-2.489-2.813-.135-.12,2.489-.879-.042.278-5.809.88.042-.125,2.6,2.813.135.125-2.6Z",
    transform: "translate(-42.016 -57.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M85.642,160.675a2.934,2.934,0,0,1,1.41.666,2.69,2.69,0,0,1,.79,1.234,3.537,3.537,0,0,1-.6,3.074,2.682,2.682,0,0,1-1.2.845,3.18,3.18,0,0,1-2.967-.582,2.655,2.655,0,0,1-.787-1.234,3.57,3.57,0,0,1,.6-3.074,2.656,2.656,0,0,1,1.194-.845A2.928,2.928,0,0,1,85.642,160.675Zm-.152.775a1.991,1.991,0,0,0-1.074.061,1.815,1.815,0,0,0-.828.616,2.962,2.962,0,0,0-.457,2.332,1.81,1.81,0,0,0,.534.883,2,2,0,0,0,.972.462,2.026,2.026,0,0,0,1.079-.06,1.774,1.774,0,0,0,.828-.616A3,3,0,0,0,87,162.8a1.777,1.777,0,0,0-.533-.884A2.02,2.02,0,0,0,85.49,161.449Z",
    transform: "translate(-40.134 -57.554)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M78.235,158.873,76.6,163.705l1.628.55-.229.678-4.084-1.381.229-.677,1.621.548,1.633-4.832Z",
    transform: "translate(-38.566 -57.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.692,156.637l-2.5,5.249-3.336-1.592.307-.645,2.542,1.213.781-1.634-2.317-1.106.3-.631L70.78,158.6l.809-1.695-2.542-1.213.307-.644Z",
    transform: "translate(-37.223 -56.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M66.749,153.323l-3.094,4.923-.746-.468,2.723-4.332L63.4,152.039l.371-.591Z",
    transform: "translate(-36.473 -55.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.374,145.065a2.828,2.828,0,0,1,.828,1.3,2.528,2.528,0,0,1-.018,1.432,3.787,3.787,0,0,1-2.152,2.287,2.552,2.552,0,0,1-1.431.109,2.8,2.8,0,0,1-1.348-.743,2.661,2.661,0,0,1-.875-1.508,2.221,2.221,0,0,1,.357-1.58l.715.672a1.381,1.381,0,0,0-.19.928,1.614,1.614,0,0,0,.54.918,1.717,1.717,0,0,0,1.411.512,2.433,2.433,0,0,0,1.487-.842,2.4,2.4,0,0,0,.741-1.527,1.72,1.72,0,0,0-.6-1.375,1.677,1.677,0,0,0-.938-.494,1.3,1.3,0,0,0-.892.221L52.3,144.7a2.168,2.168,0,0,1,1.527-.422A2.686,2.686,0,0,1,55.374,145.065Z",
    transform: "translate(-34.072 -54.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.34,138.477a2.908,2.908,0,0,1,.636,1.423,2.679,2.679,0,0,1-.2,1.452,3.536,3.536,0,0,1-2.459,1.94,2.684,2.684,0,0,1-1.46-.14,3.18,3.18,0,0,1-1.872-2.374,2.651,2.651,0,0,1,.206-1.448,3.576,3.576,0,0,1,2.459-1.94,2.661,2.661,0,0,1,1.457.137A2.919,2.919,0,0,1,49.34,138.477Zm-.62.489a1.977,1.977,0,0,0-.854-.654,1.8,1.8,0,0,0-1.029-.071,2.956,2.956,0,0,0-1.866,1.472,1.81,1.81,0,0,0-.17,1.017A2.186,2.186,0,0,0,46.1,142.37a1.764,1.764,0,0,0,1.029.071,3,3,0,0,0,1.866-1.471,1.772,1.772,0,0,0,.17-1.018A2.014,2.014,0,0,0,48.72,138.966Z",
    transform: "translate(-32.861 -53.129)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.043,132.741l-5.082,2.828-.5-.908,2.426-3.6-4.336.169-.5-.908,5.081-2.828.428.769-3.753,2.09,3.891-.132.332.6-2.151,3.241,3.745-2.085Z",
    transform: "translate(-31.55 -51.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.676,124.479l-5.428,2.088-1.309-3.4.667-.257.993,2.582,1.713-.659-.823-2.14.659-.254.823,2.14,2.388-.918Z",
    transform: "translate(-30.963 -50.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.848,114.74a2.923,2.923,0,0,1-.024,1.56,2.69,2.69,0,0,1-.8,1.23,3.538,3.538,0,0,1-3.048.721,2.687,2.687,0,0,1-1.264-.742,3.185,3.185,0,0,1-.7-2.943,2.667,2.667,0,0,1,.8-1.226,3.571,3.571,0,0,1,3.048-.721,2.656,2.656,0,0,1,1.264.738A2.926,2.926,0,0,1,37.848,114.74Zm-.768.182a1.993,1.993,0,0,0-.5-.954,1.817,1.817,0,0,0-.9-.5,2.957,2.957,0,0,0-2.312.548,1.8,1.8,0,0,0-.584.851,1.991,1.991,0,0,0-.019,1.076,2.017,2.017,0,0,0,.5.957,1.776,1.776,0,0,0,.9.5,3,3,0,0,0,2.312-.547,1.766,1.766,0,0,0,.584-.851A2.015,2.015,0,0,0,37.079,114.922Z",
    transform: "translate(-30.576 -48.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.574,108.393l-5.79.54-.186-1.994a2.439,2.439,0,0,1,.126-1.151,1.551,1.551,0,0,1,.563-.716,1.8,1.8,0,0,1,.853-.3,1.761,1.761,0,0,1,1,.195,1.581,1.581,0,0,1,.712.831L36.2,104.34l.095,1.017L34.063,106.7l.1,1.034,2.333-.217Zm-3.077-.6-.1-1.067a1.169,1.169,0,0,0-.371-.846,1.053,1.053,0,0,0-.779-.207,1.011,1.011,0,0,0-.715.342,1.208,1.208,0,0,0-.195.911l.1,1.059Z",
    transform: "translate(-30.327 -46.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.127,99.493l-5.1-.138-.046,1.719-.714-.019.116-4.31.715.019-.047,1.71,5.1.137Z",
    transform: "translate(-30.267 -45.406)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.761,86.832a2.711,2.711,0,0,1-.687,1.316,2.542,2.542,0,0,1-1.235.7,3.439,3.439,0,0,1-1.606-.022,3.4,3.4,0,0,1-1.452-.693,2.6,2.6,0,0,1-.816-1.208,2.9,2.9,0,0,1-.034-1.572,2.752,2.752,0,0,1,.844-1.511,2.2,2.2,0,0,1,1.489-.543l-.224.971a1.29,1.29,0,0,0-.831.345,1.755,1.755,0,0,0-.485.92,1.823,1.823,0,0,0,.251,1.534,2.8,2.8,0,0,0,3.163.738,1.739,1.739,0,0,0,.875-1.2,1.65,1.65,0,0,0-.185-1.377,2.2,2.2,0,0,0-1.156-.792l-.355,1.538-.664-.153.555-2.4,3.076.71-.182.785-.85-.12a2.082,2.082,0,0,1,.524.871A2.313,2.313,0,0,1,37.761,86.832Z",
    transform: "translate(-30.565 -42.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.214,78.375a2.548,2.548,0,0,1-.635.961,1.849,1.849,0,0,1-.99.471,2.529,2.529,0,0,1-1.307-.19L33.9,78.3l.319-.821L37.608,78.8a1.511,1.511,0,0,0,1.178.065,1.536,1.536,0,0,0,.712-1.836,1.513,1.513,0,0,0-.913-.746l-3.392-1.316.319-.821L38.9,75.458a2.468,2.468,0,0,1,1.091.748,1.885,1.885,0,0,1,.407,1.031A2.577,2.577,0,0,1,40.214,78.375Z",
    transform: "translate(-30.955 -41.108)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42.417,73.678,38.348,69l.463-.845,6.122.93-.447.816L43,69.658l-1.142,2.084,1.006,1.12Zm-1.05-2.49.9-1.646-2.775-.451Z",
    transform: "translate(-31.798 -39.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.658,65.989l-4.693-3.434,1.182-1.615A2.437,2.437,0,0,1,44,60.161,1.546,1.546,0,0,1,44.9,60a1.8,1.8,0,0,1,.835.344,1.757,1.757,0,0,1,.622.81,1.581,1.581,0,0,1-.018,1.094l2.723.458-.6.824L45.9,63.056l-.614.839,1.891,1.383ZM44.751,63.5l.633-.865a1.162,1.162,0,0,0,.283-.879,1.048,1.048,0,0,0-.446-.671,1.013,1.013,0,0,0-.762-.218,1.213,1.213,0,0,0-.75.553l-.627.858Z",
    transform: "translate(-32.483 -38.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M51.377,60.268,48.646,54.7l.665-.7,5.676,2.474-.642.674-1.372-.619-1.64,1.72.685,1.341ZM51,57.592l1.3-1.359L49.73,55.083Z",
    transform: "translate(-33.749 -37.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M57.336,53.78l-3.619-4.552.689-.549,5.007,1.613-2.724-3.427.689-.549L61,50.87l-.689.548L55.3,49.806l2.725,3.427Z",
    transform: "translate(-34.726 -35.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.4,48.043l-2.633-4.37-1.474.888-.369-.612,3.694-2.225.369.612-1.465.883,2.632,4.37Z",
    transform: "translate(-36.095 -34.936)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M70.7,45.216l-2.39-5.3,3.371-1.52.293.652L69.408,40.2l.744,1.651L72.493,40.8l.287.636-2.341,1.055L71.21,44.2l2.568-1.157.293.652Z",
    transform: "translate(-37.501 -34.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M77.469,42.454l-1.742-5.548L79.254,35.8l.214.682-2.687.844.542,1.728,2.449-.769.209.666-2.449.768.562,1.791,2.687-.844.215.682Z",
    transform: "translate(-38.911 -33.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M89.3,38.553a1.021,1.021,0,0,1-.545-.068,1.1,1.1,0,0,1-.434-.322,1.007,1.007,0,0,1-.216-.511,1.023,1.023,0,0,1,.071-.554,1.077,1.077,0,0,1,.331-.431,1.028,1.028,0,0,1,.507-.212,1.045,1.045,0,0,1,.554.066,1.049,1.049,0,0,1,.644.843,1.025,1.025,0,0,1-.067.55,1.069,1.069,0,0,1-.327.426A1.047,1.047,0,0,1,89.3,38.553Z",
    transform: "translate(-41.261 -33.935)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.385 55.9)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 46.063,
    transform: "translate(41.215 9.698)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 46.063,
    transform: "translate(14.546 9.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M92.193,126.9V113.564h9.7V126.9",
    transform: "translate(-69.161 -71.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M87.706,82.157H90.13v2.424",
    transform: "translate(-68.311 -65.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.653,82.157h2.424v2.424",
    transform: "translate(-71.711 -65.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M96.679,82.157H99.1v2.424",
    transform: "translate(-70.011 -65.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M87.706,92.626H90.13V95.05",
    transform: "translate(-68.311 -67.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72.75,92.626h2.424V95.05",
    transform: "translate(-65.477 -67.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72.75,103.095h2.424v2.424",
    transform: "translate(-65.477 -69.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.608,103.095h2.424v2.424",
    transform: "translate(-74.545 -69.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.608,113.564h2.424v2.424",
    transform: "translate(-74.545 -71.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72.75,113.564h2.424v2.424",
    transform: "translate(-65.477 -71.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.608,92.626h2.424V95.05",
    transform: "translate(-74.545 -67.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.653,92.626h2.424V95.05",
    transform: "translate(-71.711 -67.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M96.679,92.626H99.1V95.05",
    transform: "translate(-70.011 -67.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M87.706,103.095H90.13v2.424",
    transform: "translate(-68.311 -69.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.653,103.095h2.424v2.424",
    transform: "translate(-71.711 -69.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M96.679,103.095H99.1v2.424",
    transform: "translate(-70.011 -69.154)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 36.366,
    transform: "translate(2.424 19.395)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 36.366,
    transform: "translate(53.336 19.395)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 10.91,
    transform: "translate(0 19.395)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 10.91,
    transform: "translate(44.851 19.395)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 31.517,
    transform: "translate(12.122 9.698)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 55.761,
    transform: "translate(0 55.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.7,71.767V65.706h12.122v6.061",
    transform: "translate(-68.877 -62.069)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 3.637,
    transform: "translate(27.88 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.541f527fcf5dafe6557785df4d37d78d.svg";
export { ForwardRef as ReactComponent };